import { motion } from "framer-motion";
import { waLink, WhatsAppIcon } from "@/lib/whatsapp";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-0 overflow-hidden bg-[#25D366] text-white shadow-[0_8px_30px_rgba(0,0,0,0.35)]"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
    >
      <span className="flex h-14 w-14 items-center justify-center">
        <WhatsAppIcon className="h-7 w-7" />
      </span>
      <span className="hidden pr-5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] md:block">
        Chat now
      </span>
    </motion.a>
  );
}
